/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
import { FC } from 'react';
import Select from 'react-select';

export interface SimpleSelectProps {
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  options?: any;
  placeholder?: string | undefined;
  [x: string]: any;
  value?: any;
  defaultValue?: any;
  disabled?: boolean;
  isError?: boolean;
  menuPlacement?: string;
  isSearchable?: boolean
}

export const SimpleSelect: FC<SimpleSelectProps> = ({
  options,
  onChange,
  onBlur,
  value,
  defaultValue,
  placeholder = 'select',
  restProps,
  disabled = false,
  isError = false,
  menuPlacement='bottom',
  isSearchable,
}: SimpleSelectProps) => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      height: 32,
      fontSize: 16,
      borderRadius: 4,
      paddingLeft: 12,
      border: isError ? '1px solid red' : '1px solid white',
      backgroundColor: 'white',
      fontWeight:600,
      boxShadow: state.isFocused ? '0 0 0 1px #7B1B67' : 'none',
      borderColor: state.isFocused ? '#7B1B67' : isError ? 'red' : 'white',
      '&:hover': {
        borderColor: 'white',
      },
    }),
    option: (
      styles: any,
      { isDisabled, isFocused, isSelected }: any
    ) => ({
      ...styles,
      color: '#7B1B67',
      backgroundColor: isSelected
        ? '#c9a0c0'
        : isFocused
        ? '#c9a0c0'
        : 'white',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: '#7B1B67',
      '&:hover': {
        color: '#7B1B67',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <Select
      menuPlacement={menuPlacement}
      styles={customStyles}
      options={options}
      className="sd-classes-select"
      placeholder={placeholder}
      theme={(theme: any) => ({
        ...theme,
        borderRadius: 10,
        colors: {
          ...theme.colors,
          primary25: '#7B1B67', // option Hover colour
          neutral80: '#7B1B67', // typing Inside the select
          neutral20: 'white', // Outline colour
          primary: 'white',
          neutral30: 'white',
        },
      })}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      defaultValue={defaultValue}
      isDisabled={disabled}
      isSearchable={isSearchable}
      {...restProps}
    />
  );
};

export default SimpleSelect;
